import Column from '@amzn/meridian/column';
import styled from '@emotion/styled';

/** Top-level page column whose side margins scale with the viewport width. */
const PageColumn = styled(Column)`
    padding: 0 clamp(5px, 5vw, 200px);
`;

export { PageColumn };
